import Layout from '../components/Layout';
import * as React from "react";
import KaiZenHero from "../components/KaiZen/KaiZenHero/KaiZenHero";
import DidYouKnow from "../components/DidYouKnow";
import WhyKaiZen from '../components/KaiZen/WhyKaiZen/WhyKaiZen';
import KaiZenIsDifferent from "../components/KaiZen/KaiZenIsDifferent/KaiZenIsDifferent";
import CarouselEditor from '../components/Editor/CarouselEditor';
import FindAgent from "../components/FindAgent";
import {GetServerSideProps} from "next";
import AppContext from "../components/AppContext";
import { useRouter } from 'next/router';
import EstimationFinal from "../components/KaiZen/Estimation/EstimationFinal";
import Disclaimer from "../components/Disclaimer/Disclaimer";
import fetchData from "../lib/fetchData";

export const getServerSideProps: GetServerSideProps = fetchData('/api/pages/kai-zen');

function KaiZenStrategy(props: any) {
    const {
        kaizenTitle,
        kaizenSlogan,
        kaizenSloganDescendantText,
        strategyText,
        strategyDescendantText,
        didYouKnow,
        didYouKnowDescendantText,
        whyKaizen,
        whyKaizenDescendantText,
        valueProvided,
        valueProvidedList,
        requiredQualifications,
        requiredQualificationsList,
        kaizenDifferent,
        kaizenDifferentDescendantText,
        smartLeverage,
        smartLeverageList,
        moreProtection,
        moreProtectionList,
        moreGrowth,
        moreGrowthList,
        niwStrategy,
        findAgentTitle,
        findAgentSubTitle,
        findAgentByZipTitle,
        imgEmployeehandshake,
        kaiZenEstimator,
        bgImage,
        carouselId,
        videoUrl,
        iliaTitle,
        iliaDesc,
        iliaStrategyList
    } = props.data;

    const [step, setStep] = React.useState(0);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [isUnderstandDisclaimer, setUnderstandDisclaimer] = React.useState(false);
    const router = useRouter();

    React.useEffect(() => {
        const {landing} = router.query;
        if (landing) {
            setStep(Number(landing));
        }
    });

    if (step === 2) {
        return (
            <AppContext.Provider value={props.page}>
                <Layout title={props.title} keyword={props.keyword} pageDescription={props.description}>
                    <EstimationFinal
                        iliaTitle={iliaTitle}
                        iliaDesc={iliaDesc}
                        iliaStrategyList={iliaStrategyList}/>
                </Layout>
            </AppContext.Provider>
        );
    }

    return (
        <AppContext.Provider value={props.page}>
            <Layout title={props.title} description={kaizenSloganDescendantText} keyword={props.keyword} pageDescription={props.description}>
                <KaiZenHero
                    kaizenTitle={kaizenTitle}
                    kaizenSlogan={kaizenSlogan}
                    kaizenSloganDescendantText={kaizenSloganDescendantText}
                    strategyText={strategyText}
                    strategyDescendantText={strategyDescendantText}
                    bgImage={bgImage}
                    videoUrl={videoUrl}
                    setOpenDialog={setOpenDialog}
                    isUnderstandDisclaimer={isUnderstandDisclaimer}
                />
                <DidYouKnow didYouKnow={didYouKnow} didYouKnowDescendantText={didYouKnowDescendantText}/>
                <WhyKaiZen
                    whyKaizen={whyKaizen}
                    whyKaizenDescendantText={whyKaizenDescendantText}
                    valueProvided={valueProvided}
                    valueProvidedList={valueProvidedList}
                    requiredQualifications={requiredQualifications}
                    requiredQualificationsList={requiredQualificationsList}
                    kaiZenEstimator={kaiZenEstimator}
                />
                <KaiZenIsDifferent
                    kaizenDifferent={kaizenDifferent}
                    kaizenDifferentDescendantText={kaizenDifferentDescendantText}
                    smartLeverage={smartLeverage}
                    smartLeverageList={smartLeverageList}
                    moreProtection={moreProtection}
                    moreProtectionList={moreProtectionList}
                    moreGrowth={moreGrowth}
                    moreGrowthList={moreGrowthList}
                    niwStrategy={niwStrategy}
                    imgEmployeehandshake={imgEmployeehandshake}
                />
                <CarouselEditor carouselId={carouselId}/>
                <FindAgent findAgentTitle={findAgentTitle} findAgentSubTitle={findAgentSubTitle}
                           findAgentByZipTitle={findAgentByZipTitle}/>
                <Disclaimer setOpenDialog={setOpenDialog} openDialog={openDialog}
                            setUnderstandDisclaimer={setUnderstandDisclaimer}
                />
            </Layout>
        </AppContext.Provider>
    )
}
export default KaiZenStrategy;
